(function() {
    class FooterBlockAdev extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (window.innerWidth <= 749) {
          this.setupMobileCollapse();
        }
      }

      setupMobileCollapse() {
        const collapsibleColumns = this.querySelectorAll('[data-collapsible="true"]');
        
        collapsibleColumns.forEach((column) => {
          const heading = column.querySelector('.ai-footer-heading-{{ ai_gen_id }}');
          
          if (heading) {
            heading.addEventListener('click', () => {
              column.classList.toggle('active');
            });
          }
        });
      }
    }

    customElements.define('footer-block-adev', FooterBlockAdev);
  })();